import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * useUTMs — Captura parâmetros UTM da URL e persiste no sessionStorage.
 * Os UTMs são automaticamente propagados para todos os links Hotmart
 * via a função getHotmartUrl() usada nos componentes.
 *
 * Parâmetros capturados:
 *   utm_source, utm_medium, utm_campaign, utm_term, utm_content
 */
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

export function useUTMs() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const captured = {};

    UTM_KEYS.forEach((key) => {
      const value = params.get(key);
      if (value) captured[key] = value;
    });

    if (Object.keys(captured).length > 0) {
      // Mescla com UTMs já existentes (prioridade para os novos)
      const existing = JSON.parse(sessionStorage.getItem("utms") || "{}");
      const merged = { ...existing, ...captured };
      sessionStorage.setItem("utms", JSON.stringify(merged));
    }
  }, [location.search]);
}

/**
 * Retorna os UTMs capturados na sessão, para enviar junto com o lead.
 * @returns {Object} ex: { utm_source: "instagram", utm_campaign: "ebook" }
 */
export function getUTMs() {
  try {
    return JSON.parse(sessionStorage.getItem("utms") || "{}");
  } catch {
    return {};
  }
}

/**
 * Retorna a URL da Hotmart com UTMs propagados do sessionStorage.
 * @param {string} baseUrl - URL base da Hotmart
 * @returns {string} URL com UTMs anexados
 */
export function buildHotmartUrl(baseUrl) {
  try {
    const utms = JSON.parse(sessionStorage.getItem("utms") || "{}");
    const params = new URLSearchParams(utms).toString();
    return params ? `${baseUrl}&${params}` : baseUrl;
  } catch {
    return baseUrl;
  }
}
